var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigmaBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#F4F2ED",
    rx: 60
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_187)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0ACF83",
    d: "M94.3467 228C112.747 228 127.68 213.067 127.68 194.667V161.333H94.3467C75.9467 161.333 61.0133 176.267 61.0133 194.667C61.0133 213.067 75.9467 228 94.3467 228Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A259FF",
    d: "M61.0133 128C61.0133 109.6 75.9467 94.6667 94.3467 94.6667H127.68V161.333H94.3467C75.9467 161.333 61.0133 146.4 61.0133 128Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F24E1E",
    d: "M61.0133 61.3333C61.0133 42.9333 75.9467 28 94.3467 28H127.68V94.6667H94.3467C75.9467 94.6667 61.0133 79.7333 61.0133 61.3333Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7262",
    d: "M127.68 28H161.013C179.413 28 194.347 42.9333 194.347 61.3333C194.347 79.7333 179.413 94.6667 161.013 94.6667H127.68V28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1ABCFE",
    d: "M194.347 128C194.347 146.4 179.413 161.333 161.013 161.333C142.613 161.333 127.68 146.4 127.68 128C127.68 109.6 142.613 94.6667 161.013 94.6667C179.413 94.6667 194.347 109.6 194.347 128Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133.36,
    height: 200,
    fill: "#fff",
    transform: "translate(61 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaBadge);
export default __webpack_public_path__ + "static/media/Figma-Badge.8a42fba4a62f42d0b0a8688d12bd3329.svg";
export { ForwardRef as ReactComponent };